export default __webpack_public_path__ + "static/media/Iglesia.79a75c7f.bmp";